import React from 'react';
import { Flex, Box } from 'rebass';
import { setMonth, format, setYear, setDay } from 'date-fns';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import styled from 'styled-components';
import Text from '../../../Text';

const NavigationIcon = styled(Box).attrs(() => ({
  p: 1,
  color: 'chestnutRose',
}))`
  border-radius: 50%;
  width: 32px;
  height: 32px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const CalendarNavigator = ({ setPeriod, year, month, ...props }) => {
  const date = setYear(setMonth(setDay(new Date(), 1), month), year);
  const navigateToMonth = _month => {
    let newMonth = _month;
    let newYear = Number(year);
    if (_month === -1) {
      newYear -= 1;
      newMonth = 11;
    } else if (_month === 12) {
      newYear += 1;
      newMonth = 0;
    }
    setPeriod({
      year: newYear,
      month: newMonth,
    });
  };
  return (
    <Flex alignItems="center" {...props}>
      <Flex m={-1} mr={2}>
        <NavigationIcon onClick={() => navigateToMonth(month - 1)} m={1}>
          <FiChevronLeft size={24} />
        </NavigationIcon>
        <NavigationIcon onClick={() => navigateToMonth(month + 1)} m={1}>
          <FiChevronRight size={24} />
        </NavigationIcon>
      </Flex>
      <Text as="h2" fontSize={5} color="valhalla" mb={3}>
        {format(date, 'MMMM YYYY')}
      </Text>
    </Flex>
  );
};

export default CalendarNavigator;
